import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import PageLayout from '../../../common/layouts/pageLayout';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import { Form } from 'react-final-form';
import { Button, FormControl, Grid } from '@material-ui/core';
import FormHeaderMedium from '../../../common/components/forms/formHeaderMedium';
import MultiSelectStyled from '../../../common/components/input/multiSelectStyled';
import { SyntheticEvent, useEffect, useMemo, useState } from 'react';
import { setErrorFeedback } from '../../../../features/feedback/feedbackSlice';
import {
  fetchAllProcessoEmix,
  integrarExportacao,
  integrarImportacao,
  consultar,
} from '../../../../features/e-mix/EmixApi';
import { setProcesso } from '../../../../features/declaracao-importacao/declaracaoImportacaoSlice';
import SelectStyled from '../../../common/components/input/selectStyled';
import keycloak from '../../../../components/keycloak';
import { KEYCLOAK_TOKEN_TIMEOUT } from '../../../../App';
import QCXInfoAlert from '../../../../shared-components/alert/QCXInfoAlert';

interface ControlledValue {
  id: string | number;
  value: string;
}

interface FollowUpEmixDto {
  id: string | number;
  numero: string | null;
  code: string | null;
  description: string | null;
  active: boolean | null;
}

const EmixPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [selectProcesso, setSelectProcesso] = useState<any>(null);
  const [processoUltimaIntegracao, setProcessoUltimaIntegracao] = useState<any>(null);
  const [processo, setProcesso] = useState<any>([]);

  const [selectTipo, setSelectTipo] = useState<any>(null);
  const [tipo, setTipo] = useState<any>(['exportacao', 'importacao']);

  const handleSubmit = async (form: any) => {
    keycloak.updateToken(KEYCLOAK_TOKEN_TIMEOUT);

    try {
      if (selectTipo?.id === 'exportacao') {
        const response = await integrarExportacao(selectProcesso?.id);
      } else {
        const response = await integrarImportacao(selectProcesso?.id);
      }
    } catch (error) {}
  };

  useEffect(() => {
    const followUp = async () => {
      try {
        const response = await fetchAllProcessoEmix();

        if (response.status === 200) {
          console.log(response);

          setProcesso(response.data);
        } else {
          dispatch(
            setErrorFeedback({
              message: 'Erro ao buscar fornecedores.',
            })
          );
        }
      } catch (error) {
        if (axios.isCancel(error)) return;

        dispatch(
          setErrorFeedback({
            message: 'Erro ao buscar fornecedores.',
          })
        );
      }
    };

    followUp();
  }, [dispatch]);

  useEffect(() => {
    setProcessoUltimaIntegracao(null);
    console.log('selected', selectProcesso);

    if (!selectProcesso?.id) return;

    async function consultarProcessoSelecionado() {
      const response = await consultar(selectProcesso.id);
      setProcessoUltimaIntegracao(response.data);
    }

    consultarProcessoSelecionado();
  }, [selectProcesso]);

  const respostaEmixResultado = useMemo(() => {
    try {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(processoUltimaIntegracao?.resposta_emix, 'text/xml');
      const escapedInnerXml = xmlDoc.getElementsByTagName('processaDesembaracoResult')[0].textContent;
      const innerDoc = parser.parseFromString(escapedInnerXml!, 'text/xml');
      const targetMessage = innerDoc.getElementsByTagName('Mensagem')[0].textContent;
      return targetMessage;
    } catch (err) {
      return '';
    }
  }, [processoUltimaIntegracao]);

  const respostaEmixData = useMemo(() => {
    try {
      const dateObj = new Date(processoUltimaIntegracao.data_integrado_emix + 'T00:00:00');

      const formattedDate = new Intl.DateTimeFormat('pt-BR').format(dateObj);

      return formattedDate;
    } catch (err) {
      return processoUltimaIntegracao?.data_integrado_emix;
    }
  }, [processoUltimaIntegracao]);

  return (
    <PageLayout title={'E-mix'} icon={<HistoryEduIcon color={'secondary'} />}>
      <>
        <Form onSubmit={handleSubmit}>
          {({ handleSubmit, form }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={2}>
                <FormHeaderMedium>Selecione o processo para integrar :</FormHeaderMedium>
              </Grid>
              <Grid item sm={12} style={{ margin: '25px 0 0 0' }}>
                <FormControl fullWidth>
                  <SelectStyled
                    key={'select-tipo'}
                    controlledValue={selectTipo}
                    options={tipo.map((p: any) => {
                      return { id: p, value: p };
                    })}
                    onChangeAction={(e, value) => {
                      if (value === null) {
                        setSelectTipo(null);
                      } else {
                        setSelectTipo(value as any);
                      }
                    }}
                    label={'Tipo'}
                  ></SelectStyled>
                </FormControl>
              </Grid>
              <Grid item sm={12} style={{ margin: '25px 0 0 0' }}>
                <FormControl fullWidth>
                  <SelectStyled
                    key={'select-processo'}
                    controlledValue={selectProcesso}
                    options={processo.map((p: any) => {
                      return { id: p.id, value: p.numero };
                    })}
                    onChangeAction={(e, value) => {
                      if (value === null) {
                        setSelectProcesso(null);
                      } else {
                        setSelectProcesso(value as any);
                      }
                    }}
                    label={'Processo'}
                  ></SelectStyled>
                </FormControl>
              </Grid>
              <Grid item xs={12} style={{ margin: '25px 0 0 0' }}>
                <Button variant="contained" color="secondary" type="submit">
                  Integrar
                </Button>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ margin: '25px 0 0 0', opacity: processoUltimaIntegracao?.is_integrado_emix ? 1 : 0 }}
              >
                <QCXInfoAlert>
                  Processo integrado em {respostaEmixData}
                  {respostaEmixResultado
                    ? ` com a
                  resposta: ${respostaEmixResultado}`
                    : ''}
                </QCXInfoAlert>
              </Grid>
            </form>
          )}
        </Form>
      </>
    </PageLayout>
  );
};

export default EmixPage;
